export const MS_PER_SEC = 1000;

export function formatDurationMs(ms, { style = 'hms', showMs = false } = {}) {
    const totalMs = Math.max(0, Math.trunc(Number(ms) || 0));
    const totalSec = Math.floor(totalMs / MS_PER_SEC);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const frac = totalMs % MS_PER_SEC;

    if (style === 'parts') return { h, m, s, ms: frac };
    if (style === 'compact') {
        if (h > 0) return `${h}h ${m}m ${s}s`;
        if (m > 0) return `${m}m ${s}s`;
        return `${s}s`;
    }
    const hms =
        `${String(h).padStart(2, '0')}:` +
        `${String(m).padStart(2, '0')}:` +
        `${String(s).padStart(2, '0')}`;
    return showMs ? `${hms}.${String(frac).padStart(3, '0')}` : hms;
}

export function toMs(date) {
    if (date == null) return null;
    const t = new Date(date).getTime();
    return Number.isFinite(t) ? t : null;
}
